export default "__VITE_ASSET__56e5a77d__"